import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { BASE_API_URL, SENRTY_DSN } from "@/model/consts/common.ts";

import App from "./app/App.tsx";
import "./index.css";

Sentry.init({
  dsn: SENRTY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Sentry.feedbackIntegration({
    //   colorScheme: "system",
    // }),
  ],
  enableLogs: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//, new RegExp(`^${BASE_API_URL}`)],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById("root");

const root = createRoot(container!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(<App />);
